import React, { useState, useEffect } from 'react';
import { notificationSystem } from '../utils/notifications';

export const NotificationProvider = ({ children }) => {
  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    const unsubscribe = notificationSystem.subscribe((notification) => {
      if (notification.action === 'remove') {
        setNotifications(prev => prev.filter(n => n.id !== notification.id));
      } else {
        setNotifications(prev => [...prev, notification]);
      }
    });

    return unsubscribe;
  }, []);

  return (
    <>
      {children}
      <div className="notification-container">
        {notifications.map((notif) => (
          <div key={notif.id} className={`notification notification-${notif.type}`}>
            {notif.message}
            <button 
              onClick={() => {
                setNotifications(prev => prev.filter(n => n.id !== notif.id));
              }}
              className="notification-close"
            >
              ×
            </button>
          </div>
        ))}
      </div>
    </>
  );
};

export default NotificationProvider;
